import React from 'react';

import styled from 'styled-components';

import { Card, Flex, Heading, Icon, Text, colors, spacing, useStylesFor as stylesFor } from '@sine/sine-ui-components';

import StoreBadge from './storeBadge.component';

const CircleBg = styled.div`
  padding: 30px;
  height: 84px;
  width: 84px;
  margin: 0 auto 20px;
  border-radius: 500px;
  background: ${colors.primary500};
`;

const StyledText = styled(Text)`
  display: block;
  text-align: center;
  margin-bottom: ${spacing(2)};
`;

const CheckInCard = styled.div`
  text-align: center;
  padding: 0 ${spacing(2)};
  margin-bottom: ${spacing(1)};
`;

const StyledCardWrapper = styled(Card)`
  margin-top: ${spacing(2.3)};
  max-width: 100%;
`;

const StyledFlex = styled(Flex)`
  ${stylesFor('mobile').andSmaller`
    flex-direction: column;
    align-items: stretch;
  `}
`;

export default function HelpBanner() {
  return (
    <StyledCardWrapper>
      <Card.Header title='There are 3 ways a visitor can check in...' />

      <Card.Content>
        <StyledFlex justifyContent='center' wrap='nowrap'>
          <CheckInCard>
            <CircleBg>
              <Icon type='arrow-check-in' color={colors.white} size='lg' />
            </CircleBg>
            <Heading type='h3'>Web</Heading>
            <StyledText>Press the Check-in button above and check-in now</StyledText>
          </CheckInCard>

          <CheckInCard>
            <CircleBg>
              <Icon type='android' color={colors.white} size='lg' />
            </CircleBg>
            <Heading type='h3'>Sine Pro for Mobile</Heading>
            <StyledText>Download Sine on your mobile and check-in now to a site nearby to you</StyledText>

            <Flex justifyContent='center' alignItems='center' gap={1}>
              <StoreBadge app='sinePro' />
              <StoreBadge app='sinePass' />
            </Flex>
          </CheckInCard>

          <CheckInCard>
            <CircleBg>
              <Icon type='ipad' color={colors.white} size='lg' />
            </CircleBg>
            <Heading type='h3'>Sine Point Pro for iPad</Heading>
            <StyledText>Place your Sine Point iPad at your front desk or contractor point</StyledText>

            <StoreBadge app='sinePoint' />
          </CheckInCard>
        </StyledFlex>
      </Card.Content>
    </StyledCardWrapper>
  );
}
